<template>
  <Row type="none" class="bg-white rounded shadow min-h-screen">

      <div class="pt-3" v-if="isMobileApp()">
          <Alert class="text-center" v-html="$t('inventory.advice')" :variant="'warning'">
          </Alert>
      </div>

      <Alert class="d-sm-none text-center" v-html="$t('inventory.advice')" v-if="!isMobileApp()"
             :variant="'warning'">
      </Alert>

      <div class="pt-3 container">
          <b-button
              variant="primary"
              id="order"
              @click="make"
          >
              {{ $t('inventory.title') }}
          </b-button>
      </div>

      <InventoryListTable class="mt-4" v-if="getInventories.length > 0"/>

      <RowColumn class="mt-3">
          <Pagination
              :search="search"
              base-url="inventory"
              :total-items="getInventoriesTotalCount"
              method-name="fetchInventories"/>
      </RowColumn>
  </Row>
</template>

<script>
import InventoryListTable from "@/components/InventoryListTable.vue";
import RowColumn from "@/components/RowColumn.vue";
import Pagination from "@/components/html/Pagination.vue";
import {mapActions, mapGetters} from "vuex";
import Alert from "../../../components/html/Alert.vue";
import Row from "@/components/html/Row.vue";

export default {
    name: "InventoryList",
    components: {Row, Alert, Pagination, RowColumn, InventoryListTable},
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'inventory.title'},
            ],
            inventoryId: null,
            search: {
                page: 1
            }
        }
    },
    computed: {
        ...mapGetters(['getInventories', 'getInventoriesTotalCount', 'getInventory'])
    },
    methods: {
        ...mapActions(['fetchInventories', 'fetchInventory', 'setInventoryDetails', 'setBreadcrumbItems']),
        make() {
            this.$i18nHelper.toUrl('inventory-make')
        },
        isMobileApp() {
            return window.isMobile()
        },
        find() {
            this
                .fetchInventory(this.inventoryId)
                .then(() => {
                    this.setInventoryDetails(this.getInventory)
                    this.$i18nHelper.toUrl('inventory/' + this.getInventory.id)
                })
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>

</style>
